import React, { Component } from 'react';
import axios from 'axios';
import { withRouter } from 'react-router-dom';
import { setAuth } from '../../helpers';


import { backendUrlUser } from '../../BackendURL';

class AuthComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: undefined
        };
    }

    componentDidMount() {
        this.getUser();
    }

    getUser() {
        setAuth();
        const jwt = sessionStorage.getItem('auth-token');

        if (!jwt) {
            this.setState({
                user: null
            });
            return;
        }

        axios.post(backendUrlUser + '/authgetUser').then(res => {
            if (res.data.status === "Verified") {
                this.setState({
                    user: res.data
                })
            }
        }).catch(err => {
            // console.log("Issue Here", err);

            this.props.history.push('/login');
        });
    }

    render() {
        const { user } = this.state;
        if (user === undefined) {
            return (
                <div>
                    Loading...
                </div>
            );
        }

        if (user === null) {
            this.props.history.push('/login');
        }
        return this.props.children;
    }
}

export default withRouter(AuthComponent);